module.exports = __webpack_public_path__ + "static/img/service_bg_01_zh.85b0bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_bg_01_zh.png
// module id = v1CE
// module chunks = 34